var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburgerIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.5C0 0.671573 0.671573 0 1.5 0H26.5C27.3284 0 28 0.671573 28 1.5C28 2.32843 27.3284 3 26.5 3H1.5C0.671572 3 0 2.32843 0 1.5ZM0 10.5C0 9.67157 0.671573 9 1.5 9H26.5C27.3284 9 28 9.67157 28 10.5C28 11.3284 27.3284 12 26.5 12H1.5C0.671572 12 0 11.3284 0 10.5ZM1.5 18C0.671573 18 0 18.6716 0 19.5C0 20.3284 0.671572 21 1.5 21H26.5C27.3284 21 28 20.3284 28 19.5C28 18.6716 27.3284 18 26.5 18H1.5Z",
    fill: "#161C32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerIco);
export default __webpack_public_path__ + "static/media/hamburgerIco.56ae53c1.svg";
export { ForwardRef as ReactComponent };